import { createSelector } from 'reselect';

import { AppState } from '../../store/rootReducer';

const getSsoSource = (state: AppState) => state.isolatedSsoRedirect.source;
export const getSsoSourceSelector = createSelector(getSsoSource, source => source);
